"use client";
import {
  canUseMapBuilderEditor,
  isTacticStaff
} from "@gettactic/helpers/src/featureFlags";
import { useAuthenticated } from "@gettactic/hooks";

export const useIsMapBuilderEditorAllowed = () => {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();

  if (!authenticatedUser) return false;
  if (isTacticStaff(authenticatedUser)) return true;
  if (!authenticatedUser.user) return false;
  const isOwner =
    authenticatedUser.user.organization_user?.roles.includes("owner");

  if (!isOwner) return false;

  return canUseMapBuilderEditor(authenticatedUser);
};
